import React from "react";
import { CentralIconBase, type CentralIconBaseProps } from "../CentralIconBase";
import { Path } from "react-native-svg";

export const IconDotGrid1x3Horizontal: React.NamedExoticComponent<CentralIconBaseProps> = React.memo((props) => {
  return <CentralIconBase {...props} maskId="square-outlined-radius-0-stroke-1-IconDotGrid1x3Horizontal"><Path d="M2.5 11H4.5V13H2.5V11Z" fill="currentColor"/><Path d="M13 11H11V13H13V11Z" fill="currentColor"/><Path d="M19.5 11H21.5V13H19.5V11Z" fill="currentColor"/><Path d="M2.5 11H4.5V13H2.5V11Z" stroke="currentColor"/><Path d="M13 11H11V13H13V11Z" stroke="currentColor"/><Path d="M19.5 11H21.5V13H19.5V11Z" stroke="currentColor"/></CentralIconBase>;
});

export default IconDotGrid1x3Horizontal;
